import { useEffect, useState } from 'react';
import { useGetCandidateProfileIdsInListLazyQuery } from 'generated-graphql/hooks/apollo-hooks';

type UseDuplicateCandidateProfileListMembersProps = {
  candidateProfileIds: string[];
  listId: string | null;
};

type DuplicateState = {
  duplicateIds: string[];
  nonDuplicateIds: string[];
};

const initialState: DuplicateState = {
  duplicateIds: [],
  nonDuplicateIds: []
};

export const useDuplicateCandidateProfileListMembers = ({
  candidateProfileIds,
  listId
}: UseDuplicateCandidateProfileListMembersProps) => {
  const [state, setState] = useState<DuplicateState>(initialState);

  const [fetchIdsInList, { loading }] =
    useGetCandidateProfileIdsInListLazyQuery({ fetchPolicy: 'network-only' });

  useEffect(() => {
    if (!listId || candidateProfileIds.length === 0) {
      setState({
        duplicateIds: [],
        nonDuplicateIds: candidateProfileIds
      });
      return;
    }

    const fetchDuplicates = async () => {
      const { data } = await fetchIdsInList({
        variables: { candidateProfileListId: listId, candidateProfileIds }
      });
      const existingIds = data?.getCandidateProfileIdsInListForUser;

      if (!existingIds) return;

      setState({
        duplicateIds: existingIds,
        nonDuplicateIds: candidateProfileIds.filter(
          (id) => !existingIds.includes(id)
        )
      });
    };

    fetchDuplicates();
  }, [candidateProfileIds, listId]);

  return {
    ...state,
    isLoading: loading
  };
};
